import { RagIndex } from '@/core/indexesEnum';
import { computed, ComputedRef } from 'vue';

export function useStreaming(
  ragIndex: ComputedRef<RagIndex | string | undefined>
): ComputedRef<boolean> {
  return computed(
    () =>
      ragIndex.value === RagIndex.NAW ||
      ragIndex.value === RagIndex.ECAY ||
      ragIndex.value === RagIndex.CissContable ||
      ragIndex.value === RagIndex.CissFiscal ||
      ragIndex.value === RagIndex.CissLaboral
  );
}
